import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[restrictTo]'
})

export class InlineValidationDirective {
  private el: NgControl;
  constructor(private ngControl: NgControl) {
    this.el = ngControl;
  }
  @Input() valType: string = null;
  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    if (this.valType === 'charOnly') {
      this.el.control.patchValue(value.replace(/[^A-Za-z ]/g, ''));
    } else if (this.valType === 'numberOnly') {
      this.el.control.patchValue(value.replace(/[^0-9]/g, ''));
    } else if (this.valType === 'alphaNum') {
      this.el.control.patchValue(value.replace(/[^a-z A-Z 0-9 ,-/.&()]/g, ''));
    }
    return;
  }
}
